module.exports = __webpack_public_path__ + "static/media/hcm-district7.53c4f138.svg";